<template>
  <v-row>
    <v-col cols="12" class="lx-page-head">
      <span class="kicker">Medium-Term Forecaster · H2F2</span>
      <h1>52-week market outlook</h1>
      <h4 class="mt-2">
        See our baseline market forecasts for the year ahead, compare them with the market consensus,
        and create alternative forecasts using H2F2 technology. You can choose the S&amp;P500 to be
        exogenous (determined outside of the model) or endogenous (determined by the model).
        Prediction intervals, model performance and the drivers behind each forecast are shown
        beneath the chart when the backend provides them. For specific instructions, open
        <a href="#" @click.prevent="$emit('open-methodology')">Methodology &amp; how to use</a>.
      </h4>
      <div v-if="illustrative" class="lx-banner mt-4" role="note">
        <div>
          <span class="lx-banner__title">Illustrative fixture data</span>
          This page is running against local fixtures (<code>VUE_APP_FORECAST_V2_MOCK=true</code>).
          Observed history, consensus inputs, coefficients and holdout metrics come from real
          artefacts; the forecast paths and intervals are generated by a simple illustrative
          engine, not by H2F2. Nothing here is a live forecast.
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ForecastHeader",
  props: { illustrative: { type: Boolean, default: false } },
  emits: ["open-methodology"],
};
</script>
